function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "type", "custom"],
  _excluded2 = ["id", "type", "custom"],
  _excluded3 = ["id", "realm", "type", "custom"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint consistent-return: 0 */
import { isString, isArray, isNumber, isObject } from './utils';
import defaultValues from './object-defaults';

/**
 * Object input
 *
 * The root object should at least an `id` and `type`. The object will be passed
 * as-if if those two fields are missing.
 *
 * Any field containing an object or array will be formated recursivly.
 *
 * Example object:

 * ```
 * {
 * type: 'Listing',
 * id: 'search-query',
 * items: [{
 * type: 'ClassifiedAd',
 * id: 'ad-123'
 * }]
 *}
 *```
 */

function rewriteObjectType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var objectType = type.toLowerCase();
  if (objectType === 'classifiedad') {
    objectType = 'classified';
  }
  if (objectType === 'notificationcontent') {
    objectType = 'notification';
  }
  if (objectType === 'businesstransaction') {
    objectType = 'transaction';
  }
  return objectType;
}
export function sdrn(id, providerId, type) {
  if ((isString(id) || isNumber(id)) && isString(providerId) && isString(type)) {
    var contentType = rewriteObjectType(type);
    return "sdrn:".concat(providerId, ":").concat(contentType, ":").concat(id);
  }
}
function formatUIElement(_ref) {
  var object = _ref.object,
    target = _ref.target,
    provider = _ref.provider;
  var id = object.id,
    type = object.type,
    custom = object.custom,
    rest = _objectWithoutProperties(object, _excluded);
  var _ref2 = target || {},
    targetId = _ref2.id,
    targetType = _ref2.type;
  var _ref3 = provider || {},
    providerId = _ref3.id;
  return _objectSpread({
    '@id': "sdrn:".concat(providerId, ":").concat(rewriteObjectType(targetType), ":").concat(targetId, ":element:").concat(id),
    '@type': type,
    'spt:custom': custom
  }, rest);
}
function formatDefaultObject(_ref4) {
  var _ref4$object = _ref4.object,
    object = _ref4$object === void 0 ? {} : _ref4$object,
    _ref4$provider = _ref4.provider,
    provider = _ref4$provider === void 0 ? {} : _ref4$provider;
  var id = object.id,
    _object$type = object.type,
    type = _object$type === void 0 ? 'Content' : _object$type,
    custom = object.custom,
    rest = _objectWithoutProperties(object, _excluded2);
  var providerId = provider.id;
  var fullId = sdrn(id, providerId, type);
  var base = fullId ? {
    '@id': fullId,
    '@type': type
  } : {};
  if (custom) {
    base['spt:custom'] = custom;
  }
  return Object.assign(base, rest);
}
function formatAccount(_ref5) {
  var object = _ref5.object;
  var id = object.id,
    _object$realm = object.realm,
    realm = _object$realm === void 0 ? 'schibsted.com' : _object$realm,
    type = object.type,
    custom = object.custom,
    rest = _objectWithoutProperties(object, _excluded3);
  if (!id) {
    return;
  }
  return _objectSpread({
    '@id': "sdrn:".concat(realm, ":user:").concat(id),
    '@type': 'Account',
    accountId: id
  }, rest);
}
var objectFormatterMapping = {
  UIElement: formatUIElement,
  Account: formatAccount
};
function getFormatter(type) {
  return objectFormatterMapping[type] || formatDefaultObject;
}
export default function formatObject(data) {
  var _ref6 = data || {},
    _ref6$object = _ref6.object,
    objectInput = _ref6$object === void 0 ? {} : _ref6$object;
  var evaluatedObjectInput = Object.keys(objectInput).reduce(function (accl, key) {
    var prop = objectInput[key];
    if (isArray(prop)) {
      return _objectSpread(_objectSpread({}, accl), {}, _defineProperty({}, key, prop.map(function (o) {
        if (isObject(o)) {
          return formatObject(_objectSpread(_objectSpread({}, data), {}, {
            object: o
          }));
        }
        return o;
      })));
    }
    if (isObject(prop)) {
      return _objectSpread(_objectSpread({}, accl), {}, _defineProperty({}, key, formatObject(_objectSpread(_objectSpread({}, data), {}, {
        object: prop
      }))));
    }
    return _objectSpread(_objectSpread({}, accl), {}, _defineProperty({}, key, prop));
  }, {});
  return getFormatter(objectInput.type)(_objectSpread(_objectSpread({}, data), {}, {
    object: evaluatedObjectInput
  }));
}
export var defaultValue = defaultValues;